const NetworkStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export default NetworkStatus;
